const joinLabels = (labels = []) => {
  const normalizedLabels = Array.isArray(labels)
    ? labels.map((label) => String(label || '').trim()).filter(Boolean)
    : [];

  if (normalizedLabels.length === 0) {
    return '';
  }

  if (normalizedLabels.length === 1) {
    return normalizedLabels[0];
  }

  if (normalizedLabels.length === 2) {
    return `${normalizedLabels[0]} or ${normalizedLabels[1]}`;
  }

  return `${normalizedLabels.slice(0, -1).join(', ')}, or ${normalizedLabels[normalizedLabels.length - 1]}`;
};

export const extractRequestErrorDetails = (error) => {
  const payload = error?.response?.data;
  const message = Array.isArray(payload?.message)
    ? payload.message.join(', ')
    : payload?.message || payload?.error || error?.message || '';

  return {
    statusCode: payload?.statusCode || error?.response?.status,
    message,
    error: payload?.error || '',
    code: payload?.code || '',
    permissionLabels: Array.isArray(payload?.permissionLabels) ? payload.permissionLabels : [],
    requiredPermissions: Array.isArray(payload?.requiredPermissions) ? payload.requiredPermissions : [],
    requiredPermissionMode: payload?.requiredPermissionMode || 'all',
    recommendedAction: payload?.recommendedAction || '',
    currentRole: payload?.currentRole || '',
  };
};

export const extractRequestErrorMessage = (
  error,
  fallbackMessage = 'Request failed',
  options = {},
) => {
  const details = extractRequestErrorDetails(error);
  const actionLabel = String(options?.actionLabel || '').trim();

  if (details.statusCode === 403) {
    const requiredLabelText = joinLabels(details.permissionLabels);
    const messagePrefix = actionLabel
      ? `You do not have permission to ${actionLabel}.`
      : 'You do not have permission to complete this action.';
    const requiredText = requiredLabelText
      ? ` Required: ${requiredLabelText}.`
      : '';
    const roleText = details.currentRole
      ? ` Current role: ${details.currentRole}.`
      : '';
    const nextStepText = details.recommendedAction
      ? ` ${details.recommendedAction}`
      : ' Ask a tenant administrator to review your role and permissions.';

    if (details.message && details.message !== 'Forbidden resource') {
      return details.message;
    }

    return `${messagePrefix}${requiredText}${roleText}${nextStepText}`.trim();
  }

  return details.message || fallbackMessage;
};

export const isPermissionDeniedError = (error) => extractRequestErrorDetails(error).statusCode === 403;
